// extracted by mini-css-extract-plugin
module.exports = {"cellCenter":"Table_cellCenter__3Ujud","whiteContainer":"Table_whiteContainer__1Sgs2","whiteHeadCell":"Table_whiteHeadCell__1WpdE"};